<script setup lang="ts">
defineProps<{
  message: string;
}>();
</script>

<template>
  <p data-testid="toast-description-with-link" class="text-[0.938rem]" v-html="message" />
</template>
